import { Routes } from '@angular/router';
import { locationLoadedGuard } from './guards/location-loaded.guard';
import { locationsLoadedGuard } from './guards/locations-loaded.guard';
import { videoTutorialsLoadedGuard } from '../tutorials/guards/video-tutorials-loaded.guard';
import { energyInterfacesLoadedGuard } from '../energy-interfaces/guards/energy-interfaces-loaded.guard';
import { LocationsPage } from './pages/locations-page/locations-page';
import { LocationDetailsPage } from './pages/location-details-page/location-details-page';
import { LocationDetailsEnergyInterfacesPage } from './pages/location-details-energy-interfaces-page/location-details-energy-interfaces-page';
import { LocationDetailsGeneralPage } from './pages/location-details-general-page/location-details-general-page';
import { LocationDetailsConsumptionPage } from './pages/location-details-consumption-page/location-details-consumption-page';

export const LOCATIONS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [locationsLoadedGuard, videoTutorialsLoadedGuard],
    component: LocationsPage,
  },
  {
    path: ':locationId',
    canActivate: [locationLoadedGuard],
    component: LocationDetailsPage,
    children: [
      {
        path: 'general',
        component: LocationDetailsGeneralPage,
      },
      {
        path: 'energy-interfaces',
        canActivate: [energyInterfacesLoadedGuard],
        component: LocationDetailsEnergyInterfacesPage,
      },
      {
        path: 'consumption',
        component: LocationDetailsConsumptionPage,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'general',
      },
    ],
  },
];
